import { encodeGitHubPagesUrl } from "../../website/utils/gh_route_utils";

// Hide the default 404 page content and just show a blank screen.
// The content should only be shown if the browser doesn't support JavaScript.
window.onload = () => {
  document.body.innerHTML = "";
};

// This script is used in the 404.html page to redirect the browser to the correct URL.
// Convert the current URL to a query string path and redirect the browser.
const location = window.location;
const locationUrl = new URL(location.toString());
const newUrl = encodeGitHubPagesUrl(locationUrl);
const newUrlString = newUrl
  .toString()
  .replace("https://allen-cell-animated.github.io/website-3d-cell-viewer/", "https://vole.allencell.org/");
location.replace(new URL(newUrlString));
console.log("Redirecting to " + newUrl.toString());
